var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"all"},[_c('v-header',{attrs:{"title":"详情"}}),_vm._v(" "),_c('div',{attrs:{"id":"detail"}},[_c('div',{staticClass:"conBox"},[_c('div',{staticStyle:{"padding":"0 15px"},domProps:{"innerHTML":_vm._s(_vm.html)}})])])],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-f67920a8","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/pages/msg/detail.vue
// module id = null
// module chunks = 